import styles from './index.module.scss';
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { SearchBar } from 'antd-mobile';

import backIcon from '../../assets/icon/arrow.png';
import { PopularGroupList } from '../../component/group';
import { ArticleManager } from '../../objects/article/manager';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { OrderShortType } from '../../types';

const Group = observer(() => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const seach = query.get('search'); // 'apple'

  const [searchStr, setSearchStr] = useState<string>(seach || '');

  const [articleManager] = useState<ArticleManager>(() => {
    const res = new ArticleManager();
    res.setSorter('sort_num');
    res.setOrder(OrderShortType.Descend);
    return res;
  });

  useEffect(() => {
    if (searchStr === '') return;
    articleManager.setSearch(searchStr);
    articleManager.initList();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Link to="/">
          <img src={backIcon} />
        </Link>
        <p>搜索</p>
      </div>
      <div className="p-4">
        <SearchBar
          value={searchStr}
          onChange={(value) => {
            setSearchStr(value);
          }}
          onSearch={() => {
            if (searchStr) {
              articleManager.setSearch(searchStr);
              articleManager.initList();
            }
          }}
          placeholder="请输入内容"
          style={{ '--background': '#ffffff' }}
        />
      </div>

      <div className={styles.body}>
        <PopularGroupList
          groups={articleManager.allList}
          hasMore={articleManager.hasMore}
          loadMore={() => articleManager.loadMore()}
        />
      </div>
    </div>
  );
});

export default Group;
